export default {
      id: "buble-arrow-usage",
      viewBox: "0 0 11 9",
      url: __webpack_public_path__ + "img/icons.svg#buble-arrow",
      toString: function () {
        return this.url;
      }
    }